/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createUser } from "../../redux/actions/userActions";
import { useHistory } from "react-router-dom";
import "./Register.css"; // Import the CSS file

const Register = ({ userValue, setUserValue, passwordValue, setPasswordValue }) => {
  const dispatch = useDispatch();
  const [companyValue, setCompanyValue] = useState("");
  const [passwordValue2, setPasswordValue2] = useState("");
  const [notification, setNotification] = useState({ show: false, msg: "" });
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const onCreate = () => {
    history.push("/login");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    if (userValue === "") {
      setNotification({ show: true, msg: "Username is required" });
      setIsLoading(false);
      return;
    }
    if (companyValue === "") {
      setNotification({ show: true, msg: "Company is required" });
      setIsLoading(false);
      return;
    }
    if (passwordValue === "") {
      setNotification({ show: true, msg: "Password is required" });
      setIsLoading(false);
      return;
    }
    if (passwordValue2 === "") {
      setNotification({ show: true, msg: "Confirm Password is required" });
      setIsLoading(false);
      return;
    }
    if (passwordValue !== passwordValue2) {
      setNotification({ show: true, msg: "Passwords do not match" });
      setIsLoading(false);
      return;
    }

    dispatch(
      createUser({
        username: userValue,
        password: passwordValue,
        company: companyValue,
        onCreate,
        setNotification,
      })
    );
    setIsLoading(false);
  };

  return (
    <div className="register-page-wrapper">
      <div className="register-container">
        <div className="register-header">
          <h2>Create Your Account</h2>
          <p>Please fill in the details to register</p>
        </div>

        <form className="register-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="user">Username</label>
            <Input
              name="user"
              type="email"
              value={userValue}
              autoComplete="username"
              placeholder="Enter your email"
              onChange={(e) => setUserValue(e.target.value)}
              tabIndex="1"
              className="styled-input"
            />
          </div>

          <div className="input-group">
            <label htmlFor="company">Company</label>
            <Input
              name="company"
              type="text"
              autoComplete="company"
              value={companyValue}
              placeholder="Enter your company name"
              onChange={(e) => setCompanyValue(e.target.value)}
              tabIndex="2"
              className="styled-input"
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <Input
              name="password"
              type="password"
              autoComplete="new-password"
              value={passwordValue}
              placeholder="Enter your password"
              onChange={(e) => setPasswordValue(e.target.value)}
              tabIndex="3"
              className="styled-input"
            />
          </div>

          <div className="input-group">
            <label htmlFor="password2">Confirm Password</label>
            <Input
              name="password2"
              type="password"
              autoComplete="new-password"
              value={passwordValue2}
              placeholder="Confirm your password"
              onChange={(e) => setPasswordValue2(e.target.value)}
              tabIndex="4"
              className="styled-input"
            />
          </div>

          {notification.show && (
            <p className="form-notification">{notification.msg}</p>
          )}

          <div className="button-group">
            <Button
              className="register-button"
              block={false}
              type="submit"
              fill={true}
              variant="primary"
              tabIndex="5"
              disabled={isLoading}
            >
              {isLoading ? "Creating account..." : "Create Account"}
            </Button>

            <div className="divider">
              <span>or</span>
            </div>

            <Button
              className="login-button"
              block={true}
              type="button"
              fill=""
              variant="secondary"
              tabIndex="6"
              onClick={() => history.push("/login")}
            >
              Log Into Your Account
            </Button>
          </div>
        </form>

        <div className="version-info">
          <span>Version: v2.0</span>
        </div>
      </div>
    </div>
  );
};

export default Register;